const DEFAULT_ERROR_MESSAGE = "An error occurred while saving the search."

export function getCurrentViewId() {
  let viewId = $("#userViews a.selected-view").attr("data-view-id") || $(".search_results").attr("data-default-view-id") || "";
  if (!viewId) {
    const viewIdFromParams = new URLSearchParams(window.location.search)?.get('view_id') || "";
    if (viewIdFromParams && !isNaN(parseInt(viewIdFromParams)) && viewIdFromParams.length === 26) {
      viewId = viewIdFromParams;
    }
  }
  return viewId;
}

export function saveSearchAs(filter, annotations, quicksearch_id, name, recoveryName, share, options = {}) {
  const redirect = options.redirect !== false;
  var formData = {
    authenticity_token: $('meta[name="csrf-token"]').attr('content'),
    utf8: "✓",
    saved_search: {
      Filter: filter,
      Annotations: annotations,
      Name: name
    },
    commit: 'Save'
  }

  if (quicksearch_id !== null && quicksearch_id !== '') {
    formData["QuickSearchId"] = quicksearch_id;
    formData.saved_search.QuickSearchId = quicksearch_id;
  }

  // Grab the selected view_id from the drop down, if it's on the page
  // If not, try data-default-view-id
  let viewId = getCurrentViewId();

  if (viewId) {
    formData.saved_search.ViewId = viewId;
  }

  let url = new URL($('body').attr('data-sub-nav-root-url')).pathname
  fetch(url + '/saved_searches', {
    method: 'POST',
    body: JSON.stringify(formData),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      if (redirect) {
        let basePath = routes.saved_searches_path();
        let url = new URL(basePath, window.location);

        // Add the search ID and '/listings' to the pathname
        url.pathname = url.pathname + '/' + data.search.Id + '/listings';

        // Add share parameter if needed
        if (share) {
          url.searchParams.set('share', 'true');
        }

        // Get the relative path string (pathname + search)
        let newHref = url.pathname + url.search;

        // We are saving a saved search.  Ignore the filter changed check.
        $('body').attr('data-save-search-complete','true')
  
        // SRCH-315 - Tell parent iframe to close the overlay and refresh the searches
        if ($('body').attr('data-from-market-area') === 'true') {
          parent.postMessage(JSON.stringify({
            flexmlMarketArea: true,
            action: 'closeOverlayAndRefreshSearches'  // or 'refreshSearches'
          }), '*');
        } else {
          window.location.href = newHref;
        } 
      } else {
        toast.success(options.successMessage || "Search saved successfully!"); 
      }
    } else {
      toast.error(data.error || DEFAULT_ERROR_MESSAGE);
      $('#searchName').val(recoveryName)
    }
  })
}

export async function saveSearchChanges(filter, annotations, savedSearchId, options = {}) {
  var formData = {
    authenticity_token: $('meta[name="csrf-token"]').attr('content'),
    utf8: "✓",
    saved_search: {
      Filter: filter,
      Annotations: annotations
    }
  }

  if (options.quickSearchId != null && options.quickSearchId !== '') {
    formData.saved_search.QuickSearchId = options.quickSearchId;
  }
  if (options.viewId) {
    formData.saved_search.ViewId = options.viewId;
  }

  let url = new URL($('body').attr('data-sub-nav-root-url')).pathname
  let response = await fetch(url + '/saved_searches/' + savedSearchId, {
    method: 'PUT',
    body: JSON.stringify(formData),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  })

  if (response.ok) {
    toast.success(options.successMessage || "Search saved successfully!")
    // We do not reload the page here.  So we have to reset the 'original_annotations'.
    mapSupport.original_annotations = annotations
    return true;
  }
  
  let errorMessage = await response.json()
  toast.error(errorMessage.error || DEFAULT_ERROR_MESSAGE)
  return false;
}

export async function renameSearch(name) {
  let url = window.location.href
  let modifiedUrl = url.substring(0, url.indexOf('/listings'));

  var searchTypeData = getSearchTypeData(modifiedUrl, name)

  let response = await fetch(modifiedUrl, {
    method: searchTypeData.requestMethod,
    body: JSON.stringify(searchTypeData.formData),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  })

  if (response.ok) {
    toast.success("Search renamed successfully.");
    return true
  } else {
    toast.error("Error renaming the search.")
    return false
  }
}

// Different searches need different formData to handle a name change.  This is a helper for that.
// There may need to be more types added.
function getSearchTypeData(url,name) {
  let parts = url.split('/search/');
  let searchType = null;
  let searchTypeData = null;
  if (parts.length > 1) {
    // If there is a substring after '/myapp/'
    searchType = parts[1].split('/')[0]; // Get the substring before the next '/'
  }
  if (searchType == null) {
    return null;
  }
  switch(searchType) {
    case 'collections':
      searchTypeData = {
        requestMethod: 'PUT',
        formData: {
          authenticity_token: $('meta[name="csrf-token"]').attr('content'),
          utf8: "✓",
          collection: {
            Name: name
          }
        }
      }
      break;
    case 'saved_searches':
      searchTypeData = {
        requestMethod: 'PUT',
        formData: {
          authenticity_token: $('meta[name="csrf-token"]').attr('content'),
          utf8: "✓",
          saved_search: {
            Name: name
          }
        }
      }
      break;
  }
  return searchTypeData;
}

// SortObjectByKeys: recursively sort json object so they can be compared to similar
// objects to check for equality.
// Note: arrays preserve order (we only sort the *outer* array of annotations below).
const sortObjectByKeys = (value) => {
  if (Array.isArray(value)) {
    return value.map(sortObjectByKeys);
  }
  if (value && typeof value === 'object') {
    const out = {};
    Object.keys(value).sort().forEach((k) => {
      out[k] = sortObjectByKeys(value[k]);
    });
    return out;
  }
  return value;
}

export function annotationsEqual(annotationsArry1, annotationsArry2) {

  if (annotationsArry1.length != annotationsArry2.length) {
    return false
  }

  const stringArry1 = annotationsArry1.map(obj => JSON.stringify(sortObjectByKeys(obj))).sort();
  const stringArry2 = annotationsArry2.map(obj => JSON.stringify(sortObjectByKeys(obj))).sort();

  return stringArry1.every((val, idx) => val === stringArry2[idx])
}
